import { defineFeedEntityPiniaStore } from "@bloglovin/vue-framework";

export const useSupportConversationEntityStore = defineFeedEntityPiniaStore(
  "support-conversation-entity-store",
  {
    state: () => ({}),
    getters: {},
    actions: {},
  },
);
